export default class ArgentinePostalCode {
    constructor(rawPostalCode) {
        this._rawPostalCode = rawPostalCode;
    }

    carriesProvinceLetter() {
        return Boolean(this._provinceForLetter()[this._letter()]);
    }

    province() {
        return this._provinceForLetter()[this._letter()];
    }

    _letter() {
        return (this._rawPostalCode || '').trim().charAt(0).toUpperCase();
    }

    _provinceForLetter() {
        return {
            A: 'Salta',
            B: 'Buenos Aires',
            C: 'Capital Federal',
            D: 'San Luis',
            E: 'Entre Ríos',
            F: 'La Rioja',
            G: 'Santiago del Estero',
            H: 'Chaco',
            J: 'San Juan',
            K: 'Catamarca',
            L: 'La Pampa',
            M: 'Mendoza',
            N: 'Misiones',
            P: 'Formosa',
            Q: 'Neuquén',
            R: 'Río Negro',
            S: 'Santa Fe',
            T: 'Tucumán',
            U: 'Chubut',
            V: 'Tierra del Fuego',
            W: 'Corrientes',
            X: 'Córdoba',
            Y: 'Jujuy',
            Z: 'Santa Cruz',
        };
    }
}
